<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <template v-else>
      <v-row dense>
        <v-col cols="6">
          <v-list-item class="white">
            <v-list-item-content>
              <v-list-item-subtitle>Embalagem:</v-list-item-subtitle>
              <v-list-item-title>{{
                produtoSelecionado.embalagem
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="6">
          <v-list-item class="white">
            <v-list-item-content>
              <v-list-item-subtitle>Saldo:</v-list-item-subtitle>
              <v-list-item-title>{{ getSaldoProd() }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-list-item class="white" :dense="isMobile()">
            <v-list-item-content>
              <v-select
                label="Embalagem"
                :items="produtoSelecionado.embalagens"
                item-text="descricao"
                item-value="codigo"
                v-model="pedido_item.embalagemSelecionada"
                no-data-text="Nenhuma embalagem informada"
                hide-details=""
              ></v-select>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col>
          <v-list-item class="white" :dense="isMobile()">
            <v-list-item-content>
              <v-select
                label="Tratamento"
                :items="produtoSelecionado.tratamentos"
                item-text="descricao"
                return-object
                v-model="pedido_item.tratamentoSelecionado"
                no-data-text="Nenhum tratamento encontrado"
                hide-details=""
              >
                <template v-slot:selection="{ item }">
                  {{ item.descricao }}
                  <v-chip small color="teal" dark class="ml-5"
                    >+ {{ formatarMoeda(item.valor_adicional) }}</v-chip
                  >
                </template>
                <template v-slot:item="{ item }">
                  {{ item.descricao }}
                  <v-chip color="teal" small dark class="ml-5"
                    >+ {{ formatarMoeda(item.valor_adicional) }}</v-chip
                  >
                </template>
              </v-select>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="6">
          <v-list-item class="white" :dense="isMobile()">
            <v-list-item-content>
              <v-text-field
                label="Vcto Pedido"
                disabled
                v-model="pedido_item.vencimento"
                hide-details=""
                type="date"
                ><template v-slot:label>
                  <span class="green--text">Vcto Pedido</span>
                </template></v-text-field
              >
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="6">
          <v-list-item class="white" :dense="isMobile()">
            <v-list-item-content>
              <v-text-field
                label="Vcto Cotado"
                color="info"
                v-model="vctoCotadoModel"
                type="date"
                hide-details=""
                ><template v-slot:label>
                  <span class="info--text">Vcto Cotado</span>
                </template></v-text-field
              >
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-list-item class="white">
            <v-list-item-content>
              <v-row>
                <v-col cols="3" align-self="center">
                  <v-btn
                    height="35"
                    small
                    title="Remover"
                    :disabled="pedido_item.quantidade <= 1"
                    @click="delItem()"
                    ><v-icon>mdi-minus</v-icon></v-btn
                  >
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    label="Quantidade"
                    v-model="pedido_item.quantidade"
                    hide-details=""
                    outlined
                    type="number"
                    class="input-center font-weight-bold"
                  ></v-text-field>
                </v-col>
                <v-col cols="3" align-self="center">
                  <v-btn
                    height="35"
                    small
                    title="Adicionar"
                    :disabled="pedido_item.quantidade >= getSaldoProd()"
                    @click="addItem()"
                    ><v-icon>mdi-plus</v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6">
                  <v-list-item dense class="text-center">
                    <v-list-item-content>
                      <v-list-item-subtitle>Data base</v-list-item-subtitle>
                      <v-list-item-title class="subtitle-1">{{
                        formatarData(produtoSelecionado.data_preco)
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-divider vertical inset></v-divider>
                <v-col cols="6" align-self="center">
                  <v-list-item dense class="text-center">
                    <v-list-item-content>
                      <v-list-item-subtitle>Preço base</v-list-item-subtitle>
                      <v-list-item-title class="subtitle-1">{{
                        formatarMoeda(
                          this.pedido_item.cliente.socio
                            ? produtoSelecionado.valor_lista
                            : produtoSelecionado.valor_lista_nao_socio
                        )
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <v-row dense :class="{ 'mb-12': isMobile() }">
        <v-col cols="12">
          <template v-for="(cotacao, i) in getCotacoes()">
            <v-list-item :key="i" class="white">
              <v-list-item-content
                :class="{
                  'success--text': cotacao.data == pedido_item.vencimento,
                  'info--text': cotacao.data == vctoCotado,
                }"
              >
                <v-list-item-title
                  :class="{ 'subtitle-2 font-weight-bold': isMobile() }"
                >
                  <p class="mb-2">
                    <v-chip
                      :style="{ 'letter-spacing': '1.3px' }"
                      :class="{
                        success: cotacao.data == pedido_item.vencimento,
                        info: cotacao.data == vctoCotado,
                      }"
                      x-small
                      >{{
                        cotacao.data == pedido_item.vencimento
                          ? "Pedido"
                          : "Cotação"
                      }}</v-chip
                    >
                  </p>
                  <span :class="{ 'font-weight-bold': !isMobile() }"
                    >Valor p/ pgto em {{ formatarData(cotacao.data) }}
                  </span>

                  <span class="black--text float-right">{{
                    formatarMoeda(getValorBruto(cotacao))
                  }}</span>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <p class="mt-1 mb-0">
                    Pontualidade({{ cotacao.perc_pontual }}%):
                    <span class="float-right">{{
                      formatarMoeda(getValorPontualidade(cotacao) * -1)
                    }}</span>
                  </p>
                  <p class="mt-1 mb-0">
                    Antec/Acrésc:
                    <span
                      :class="{ 'red--text': getAntecAcres(cotacao) > 0 }"
                      >{{ formatarMoeda(getAntecAcres(cotacao)) }}</span
                    >
                  </p>
                  <p class="mt-1 mb-0">
                    Sobras({{ pedido_item.perc_sobras }}%):
                    {{ formatarMoeda(pedido_item.valor_sobras) }}
                  </p>

                  <p class="mt-1 mb-0 subtitle-1">
                    Valor Líquido:
                    <v-chip
                      class="float-right"
                      :class="{
                        success: cotacao.data == pedido_item.vencimento,
                        info: cotacao.data == vctoCotado,
                      }"
                      :small="isMobile()"
                      >{{ formatarMoeda(getValorLiquido(cotacao)) }}</v-chip
                    >
                  </p>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="cotacao.data"></v-divider>
          </template>
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { formatMoeda } from "@/global";
import moment from "moment";

export default {
  computed: {
    ...mapState("insumos", [
      "produtosDisponiveis",
      "pedido_item",
      "vctoCotado",
      "pedidosOffline",
      "produtoSelecionado",
    ]),
    vctoCotadoModel: {
      get: function () {
        return this.vctoCotado;
      },
      set: function (value) {
        this.setVctoCotado(value);
      },
    },
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("insumos", ["getPedidosOffline"]),
    ...mapMutations("insumos", ["setVctoCotado", "setProdutoSelecionado"]),
    isMobile() {
      return this.$mq == "sm";
    },

    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    getEstoque() {
      return this.produtoSelecionado.estoque.find(
        (e) => e.filial == this.pedido_item.filialSelecionada.filial
      );
    },
    getSaldoProd() {
      var saldoDisp = this.getEstoque().saldo;

      if (this.produtoSelecionado.tem_remessa) {
        saldoDisp = this.getEstoque().saldo_imediato;
      }

      this.pedidosOffline.forEach((p) => {
        p.filter(
          (i) =>
            i.filial == this.pedido_item.filialSelecionada.filial &&
            i.grupo == this.produtoSelecionado.grupo &&
            i.subgrupo == this.produtoSelecionado.subgrupo &&
            i.item == this.produtoSelecionado.item
        ).forEach((poff) => {
          saldoDisp -= poff.quantidade;
        });
      });

      this.$store.state.insumos.pedido_item.saldo_disponivel = saldoDisp;

      return saldoDisp;
    },
    addItem() {
      if (typeof this.pedido_item.quantidade != "number") {
        if (
          this.pedido_item.quantidade == "" ||
          isNaN(this.pedido_item.quantidade)
        )
          this.pedido_item.quantidade = 0;
      }

      this.pedido_item.quantidade =
        parseFloat(this.pedido_item.quantidade) +
        parseFloat(this.pedido_item.embalagemSelecionada.conversao);
    },
    delItem() {
      this.pedido_item.quantidade =
        parseFloat(this.pedido_item.quantidade) -
        parseFloat(this.pedido_item.embalagemSelecionada.conversao);
    },
    getCotacoes() {
      var datasCotacoes = [this.pedido_item.vencimento];
      if (this.vctoCotado != this.pedido_item.vencimento) {
        datasCotacoes.push(this.vctoCotado);
      }
      return this.pedido_item.tratamentoSelecionado.cotacoes.filter((c) =>
        datasCotacoes.includes(c.data)
      );
    },
    getValorBruto(cotacao) {
      if (this.pedido_item.cliente.socio) {
        return cotacao.vlr_socio * this.pedido_item.quantidade;
      } else {
        return cotacao.vlr_nao_socio * this.pedido_item.quantidade;
      }
    },
    getValorPontualidade(cotacao) {
      if (this.pedido_item.cliente.socio) {
        return cotacao.vlr_pontual_socio * this.pedido_item.quantidade;
      } else {
        return cotacao.vlr_pontual_nao_socio * this.pedido_item.quantidade;
      }
    },
    getAntecAcres(cotacao) {
      if (this.pedido_item.cliente.socio) {
        return cotacao.antec_acresc_socio * this.pedido_item.quantidade;
      } else {
        return cotacao.antec_acresc_nao_socio * this.pedido_item.quantidade;
      }
    },
    getSobras() {
      if (this.pedido_item.perc_sobras > 0) {
        return (
          ((this.getValorBruto() * this.pedido_item.perc_sobras) / 100) *
          this.pedido_item.quantidade
        );
      } else {
        return 0;
      }
    },
    getValorLiquido(cotacao) {
      if (this.pedido_item.cliente.socio) {
        return cotacao.vlr_liq_socio * this.pedido_item.quantidade;
      } else {
        return cotacao.vlr_liq_nao_socio * this.pedido_item.quantidade;
      }
    },
  },
  async created() {
    this.loading = true;

    await this.getPedidosOffline();

    /*if (this.isMobile()) {
      this.setProdutoSelecionado(
        this.produtosDisponiveis.find((p) => p.id == this.$route.params.id)
      );
    }*/

    this.pedido_item.embalagemSelecionada =
      this.produtoSelecionado.embalagens[0];
    this.pedido_item.tratamentoSelecionado =
      this.produtoSelecionado.tratamentos[0];
    this.setVctoCotado(moment().format("YYYY-MM-DD"));
    this.pedido_item.quantidade =
      this.pedido_item.embalagemSelecionada.conversao;
    this.pedido_item.grupo = this.produtoSelecionado.grupo;
    this.pedido_item.subgrupo = this.produtoSelecionado.subgrupo;
    this.pedido_item.item = this.produtoSelecionado.item;
    this.pedido_item.descricao = this.produtoSelecionado.descricao;
    this.pedido_item.desconto_antec = this.produtoSelecionado.perc_antec;
    this.pedido_item.perc_datas_pagto =
      this.produtoSelecionado.perc_datas_pagto;
    this.pedido_item.perc_sobras = this.produtoSelecionado.perc_sobras;
    this.pedido_item.id = this.produtoSelecionado.id;

    if (this.pedido_item.cliente.socio) {
      this.pedido_item.unit_lista = this.produtoSelecionado.valor_lista;
    } else {
      this.pedido_item.unit_lista =
        this.produtoSelecionado.valor_lista_nao_socio;
    }

    this.loading = false;
  },
};
</script>

<style>
.v-text-field.input-center input {
  text-align: center;
}
</style>